import { call, put, takeLatest } from "redux-saga/effects";
import {
  blockUserFailure,
  blockUserStart,
  blockUserSuccess,
  createUserFailure,
  createUserStart,
  createUserSuccess,
  deleteUserFailure,
  deleteUserStart,
  deleteUserSuccess,
  updateUserFailure,
  updateUserStart,
  updateUserSuccess,
} from "../../store/features/user/userSlice";
import { fetchUsersStart } from "../../store/features/users/usersSlice";
import apiClient from "../../api/apiClient";

const path = "/api/v1/user/user/";

// CREATE
const createUserApi = async ({ data, accessToken }) => {
  try {
    const client = apiClient(accessToken, path);
    const response = await client.post("/", data);
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: error.message };
  }
};

function* handleCreateUserSaga(action) {
  try {
    const data = yield call(createUserApi, action.payload);
    yield put(createUserSuccess(data));
  } catch (error) {
    yield put(createUserFailure(error));
  }
}

// UPDATE
const updateUserApi = async ({ data, accessToken, userId }) => {
  try {
    const client = apiClient(accessToken, path);
    const response = await client.put(`${userId}/`, data);
    return response.data;
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message;
    throw new Error(errorMessage);
  }
};

function* handleUpdateUserSaga(action) {
  try {
    const data = yield call(updateUserApi, action.payload);
    yield put(updateUserSuccess(data));
  } catch (error) {
    yield put(updateUserFailure(error.message));
  }
}

// DELETE
const deleteUserApi = async ({ accessToken, userId }) => {
  try {
    const client = apiClient(accessToken, path);
    const response = await client.delete(`/${userId}/`);
    return response.data;
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message;
    throw new Error(errorMessage);
  }
};

function* handleDeleteUserSaga(action) {
  try {
    const data = yield call(deleteUserApi, action.payload);
    yield put(deleteUserSuccess(data));
    yield put(fetchUsersStart({ accessToken: action.payload.accessToken }));
  } catch (error) {
    yield put(deleteUserFailure(error.message));
  }
}

// BLOCK
const blockUserApi = async ({ data, accessToken, userId }) => {
  try {
    const client = apiClient(accessToken, path);
    const response = await client.patch(`/${userId}/block/`, data);
    return response.data;
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message;
    throw new Error(errorMessage);
  }
};

function* handleBlockUserSaga(action) {
  try {
    const data = yield call(blockUserApi, action.payload);
    yield put(blockUserSuccess(data));
    yield put(fetchUsersStart({ accessToken: action.payload.accessToken }));
  } catch (error) {
    yield put(blockUserFailure(error.message));
  }
}

export default function* userSaga() {
  yield takeLatest(createUserStart.type, handleCreateUserSaga);
  yield takeLatest(updateUserStart.type, handleUpdateUserSaga);
  yield takeLatest(deleteUserStart.type, handleDeleteUserSaga);
  yield takeLatest(blockUserStart.type, handleBlockUserSaga);
}
